import React, { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import { format } from "date-fns";
import Swal from "sweetalert2";
import requestPreSignedUrl from "../../Services/requestPreSignedUrlAws";
import api from "../../Services/api";
import './modalArquivosPlanejamento.css';

function ModalArquivosPlanejamento({
    show,
    onClose,
    pergunta,
    permissao,
    bucketName
}) {

    const [arquivos, setArquivos] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (show && pergunta?.IDPlanejamento_perguntas) {
            setLoading(true);
            consultaPlanejamentoArquivos().finally(() => setLoading(false));
        }
    }, [show, pergunta]);

    useEffect(() => {
        if (!show) {
            setArquivos(null); // Limpa os arquivos
        }
    }, [show]);

    const consultaPlanejamentoArquivos = async () => {
        console.log('pergunta', pergunta);
        try {
            const response = await api.get(
                `/planejamento/arquivo/${pergunta.IDPlanejamento_perguntas}`
            );

            if (response)
                setArquivos(response.data.Planejamento_arquivo.arquivos);

        } catch (error) {
            console.log(error);
            if (error?.response?.status === 404) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Nenhum registro encontrado',
                    text: 'Não existem arquivos associados a esta questão.',
                    confirmButtonColor: '#3085d6',
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro ao consultar arquivos',
                    text: 'Houve uma situação problemática ao buscar os arquivos.',
                    confirmButtonColor: '#d33'
                });
            }

            onClose(); // fecha o modal após erro
        }
    };

    const abrirArquivo = async (IDArquivo) => {
        const arquivo = await buscaArquivosPorID(IDArquivo);
        if (!arquivo) {
            alert("Arquivo não encontrado.");
            return;
        }



        const urlArquivo = await requestPreSignedUrl(
            permissao,
            "getObject",
            bucketName,
            arquivo.caminho,
            arquivo.nome
        );

        if (!urlArquivo) {
            alert("Não foi possível obter o URL do arquivo.");
            return;
        }

        window.open(urlArquivo, "_blank");
    };

    const buscaArquivosPorID = async (IDArquivo) => {
        try {
            const response = await api.get("/arquivo/" + IDArquivo);
            return response.data.Arquivo;
        } catch (error) {
            console.log(error);
            return error;
        }
    };

    if (loading) return null;

    return pergunta && arquivos && !loading && (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 18 }}>
                    Arquivos da questão #{pergunta.pergunta}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="tabela-scroll">
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Data de Cadastro</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {arquivos.map((arquivo) => (
                                <tr key={arquivo.IDArquivo}>
                                    <td>{arquivo.nome}</td>
                                    <td>
                                        {format(new Date(arquivo.dataCadastro), "dd/MM/yyyy")}
                                    </td>
                                    <td>
                                        <Button
                                            variant="primary"
                                            size="sm"
                                            onClick={() => abrirArquivo(arquivo.IDArquivo)}
                                        >
                                            Abrir
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalArquivosPlanejamento;
